// extracted by mini-css-extract-plugin
export default {"content":"Remove_content__9F9H9"};